/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  jQuery(".more_descr").click(function(){
      console.log('more_descr click');
      if ($(this).closest('.prdDescr-wr').hasClass("full")) {
        $(this).closest('.prdDescr-wr').removeClass("full");
      } else {
        $(this).closest('.prdDescr-wr').addClass("full");
      }	  
  });

/*
$(".more_descr").click(function(){
  $(this).parent().addClass('full').removeClass('less');

});
$(".less_descr").click(function(){
  $("html, body").animate({scrollTop: 0}, 100);
 $(this).parent().parent().addClass('less').removeClass('full');
});
*/

  $(document).ready(function(){

      var check_url = window.location.pathname;
    

    jQuery(".readmore_features").click(function(){
      console.log('faq-readmore click');
      jQuery(this).closest('.short_features').find('.wrapp-text').addClass("show");
      $(this).css("display","none");
         
      });


     jQuery('.custom-interest-field :radio').change(function() {
      var optionValue = jQuery(this).val();
      console.log(optionValue);
       if(optionValue == 'Other'){
         $('.otherDetail_field').removeClass('hidden').addClass('active');
         
       }else{
         $('.otherDetail_field').addClass('hidden').removeClass('active');
         
       }
      
    });


    
    var setHeight = function() {
      var imageHeight = $('.header__dropdown__custom .header__dropdown__image .wrapper-img').outerHeight();
      console.log('imageHeight = '+imageHeight);
      $('.header__dropdown__inner .header__dropdown__custom .more_link').css({'height': imageHeight + 'px'});
    }

    $(window).load(function() {
      setHeight();
    });

    $(window).resize(function() {
      setHeight();
    });


    

    var highestBox = 0;
    $('.custom-style-product-features .column-item .column-item__image-wrapper', this).each(function(){

      console.log(highestBox);
      if($(this).height() > highestBox) {
        highestBox = $(this).height(); 
      }
    });  
    $('.custom-style-product-features .column-item .column-item__image-wrapper',this).height(highestBox);
  });



   var current_url = window.location.href; 

   var getintouch = "contact#getintouch";
    if(current_url.indexOf(getintouch) != -1){
      console.log('getintouch');
      $('html, body').animate({
            scrollTop: $("#getintouch").offset().top
        }, 1000);
    }


   var str2 = "contact#contactForm";
    if(current_url.indexOf(str2) != -1){
      console.log('1111');
      $('html, body').animate({
            scrollTop: $("#contactForm").offset().top
        }, 1000);
    }

    var jointProtection = "accessories#joint-protection";
    if(current_url.indexOf(jointProtection) != -1){
      $('html, body').animate({
          scrollTop: $('#accessories_list').offset().top
      }, 1000, function() {
          $('.carousel--desktop').slick('slickGoTo', 4);
          $('.carousel--desktop').slick('slickGoTo', 4, false);

      });
      
    }


  




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

 function checkCookie() {
  let checkPopupVideo = getCookie("popupVideo");
  if (!checkPopupVideo) {
    setTimeout(function(){
      $('.popup-vimeo').trigger("click");
      $('.popup-modal-video').trigger("click");
      setCookie("popupVideo", true, 30);
    }, 500);
  } 
}

window.addEventListener("DOMContentLoaded", e =>
{
  document.querySelectorAll('a[href]').forEach(a =>
  {
    if (location.hostname == new URL(a.href).hostname)
      return;

    a.target = "_blank";
    a.rel = "noreferrer nofollow noopener";
  });
});

